module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEAAAABACAYAAACqaXHeAAAAwUlEQVR42u3asQqDMBQF0PyCiz/g3E/zk907unZKJ6GIFCnmNfhO4M7iwSRXklJrLZlTAAAAAAAAAAAAAAAA0Hw8h8epBA0AAAAAiAdY56m+lvEw6zzl+AKOELaXTzMF9gDp1gAAAAAAAACgI4CzNfWqfAOIyKUAny0uCuCXZzYD2FfZ1gBble4K4B8BAACARdA22APALYqQfwEAAAAAAAAAgKMxh6MxU8D9AAAAAPQG4KYoAAAAAAAAAAAAAAB58gZBhGrSl0K34AAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flags/Guernsey.png
// module id = lZJU
// module chunks = 0 62 63